<nav class="custom-nav" data-test="main-navigation">
  @if (flyout && node?.children.length > 1) {
    <div
      data-test="main-navigation-mobile--actions"
      class="custom-nav--back-container"
      (click)="back()"
    >
      <button class="btn" [attr.aria-label]="'common.back' | cxTranslate" data-test="main-navigation--back-btn">
        <mat-icon svgIcon="arrow-left"></mat-icon>
        {{ 'common.back' | cxTranslate }}
      </button>
      <button
        class="btn custom-nav--btn-close" (click)="clear()"
        data-test="main-navigation--close-btn"
        [attr.aria-label]="'common.close' | cxTranslate"
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  }
  <ul class="custom-nav--main" [attr.data-test]="'main-navigation--list' + node?.uid">
    @for (child of node?.children; track child?.target) {
      <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0 }"></ng-container>
    }
  </ul>
</nav>
<ng-template #nav let-node="node" let-depth="depth">
  <li
    [attr.data-test]="node?.uid ? 'main-navigation--list-' + node?.uid+ '-item' : undefined"
    [attr.aria-label]="node.title"
    [attr.tabindex]="getTabIndex(node, depth)"
    class="custom-nav--item" [attr.depth]="depth"
    [ngClass]="{
    'custom-nav--top-item': depth === 0,
    'custom-nav--long-item-list': node?.children?.length >= 10}"
    dpHoverer
    #listItem
  >
    <button
      class="btn custom-nav--btn"
      [attr.data-test]="node?.uid ? 'main-navigation--list-' + node?.uid+ '-item-btn' : undefined"
      [style]="node.styleAttributes"
      [class]="node.styleClasses"
      [ngClass]="{'custom-nav--top-item-value': depth === 0}"
      (click)="toggleOpenOverride($event,node)"
      [attr.aria-label]="node.title"
    >
      {{ node.title }}
      @if (shouldShowIcon(node)) {
        <mat-icon
          class="custom-nav--expand-icon" svgIcon="arrow-right"
          [attr.data-test]="node?.uid ? 'main-navigation--list-' + node?.uid+ '-item-expand-icon' : undefined"
        ></mat-icon>
      }

    </button>

    @if (showNested(node, listItem)) {
      <ul
        class="custom-nav--nested" [ngClass]="{'custom-nav--last': isLastLevel(node)}"
        [attr.data-test]="node?.uid ? 'main-navigation--list-' + node?.uid + '-nested' : undefined"
      >
        @for (child of node?.children; track child?.title) {
          <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }"></ng-container>
        }
      </ul>
    }
  </li>
</ng-template>
